import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { FaImages } from "react-icons/fa";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import Reveal from "../../../components/ui/Reveal";
import SectionTitle from "../HomePage/SectionTitle";

import { getAllGalleries } from "../../../services/gallerieServices";
import { resolveMediaUrl } from "../HomePage/homeUtils";

const Diaporama = ({ section }) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchGalleryPhotos = async () => {
      try {
        setLoading(true);

        const carrouselId = section?.carrousel_id;

        if (!carrouselId || carrouselId === 0) {
          if (mounted) setPhotos([]);
          return;
        }

        const galleries = await getAllGalleries();

        const selectedGallery = Array.isArray(galleries)
          ? galleries.find((gallery) => String(gallery.id) === String(carrouselId))
          : null;

        const activePhotos = selectedGallery?.photos
          ? selectedGallery.photos.filter((photo) =>
              typeof photo.is_active === "boolean" ? photo.is_active : true
            )
          : [];

        if (mounted) setPhotos(activePhotos);
      } catch (error) {
        console.error("Erreur lors de la récupération des photos:", error);
        if (mounted) setPhotos([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchGalleryPhotos();

    return () => {
      mounted = false;
    };
  }, [section]);

  if (loading) return null;
  if (photos.length === 0) return null;

  return (
    <section className="bg-slate-50 py-16 dark:bg-slate-950 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow="Photos"
          title="En images "
          highlight="dans l’association"
          subtitle="Une sélection de photos pour découvrir les activités, les moments forts et l’ambiance de l’association."
        />

        <Reveal>
          <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-3 shadow-xl dark:border-white/10 dark:bg-slate-900">
            <div className="mb-3 flex items-center gap-3 rounded-2xl bg-slate-50 px-4 py-3 dark:bg-slate-950">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <FaImages />
              </span>

              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-slate-400">
                  Diaporama
                </p>
                <p className="text-sm font-bold text-slate-700 dark:text-slate-200">
                  {photos.length} photo{photos.length > 1 ? "s" : ""} disponible
                  {photos.length > 1 ? "s" : ""}
                </p>
              </div>
            </div>

            <div className="section-carousel overflow-hidden rounded-[1.5rem]">
              <Carousel
                autoPlay
                infiniteLoop
                useKeyboardArrows
                showThumbs={false}
                showStatus={false}
                interval={5000}
                swipeable
                emulateTouch
              >
                {photos.map((photo) => (
                  <div key={photo.id} className="relative h-[320px] sm:h-[460px] lg:h-[620px]">
                    <img
                      src={resolveMediaUrl(photo.photo_url)}
                      alt={photo.description || photo.titre || "Photo"}
                      className="h-full w-full object-cover"
                    />

                    {(photo.description || photo.titre) && (
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-950/80 to-transparent p-6 text-left">
                        <p className="text-lg font-bold text-white">
                          {photo.titre || photo.description}
                        </p>
                      </div>
                    )}
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Diaporama;